/* Alliance header (concept): fold the desktop menu row away while the
   shopper scrolls down, bring it back on any scroll up. Only toggles a
   class; ac-chrome-header.css does the rest without changing the header's
   height, so the page never jumps and theme.js's --headerHeight stays true. */
(function () {
  "use strict";

  var header = document.querySelector(".main-header.ac-chrome");
  if (!header) return;

  var desktop = window.matchMedia("(min-width: 1200px)");
  var COMPACT = "ac-chrome--compact";
  var START = 160; // px scrolled before folding
  var SLACK = 8; // ignore jitter smaller than this
  var lastY = window.scrollY;
  var ticking = false;

  function busy() {
    var body = document.body.classList;
    return (
      body.contains("megamenu-open") ||
      body.contains("search-drawer-open") ||
      !!header.querySelector("details[open]") ||
      !!header.querySelector(":focus-visible")
    );
  }

  // Sticky page parts sit at --headerHeight or --dynamicheaderHeight
  // (collection filters). Point both at what is actually pinned so nothing
  // floats below a folded menu row; on expand, restore the full height.
  function setOffset(compact) {
    var primary = header.querySelector(".primary-header");
    var height = compact && primary ? primary.offsetHeight : header.offsetHeight;
    document.body.style.setProperty("--headerHeight", height + "px");
    document.body.style.setProperty("--dynamicheaderHeight", height + "px");
  }

  function setCompact(on) {
    if (header.classList.contains(COMPACT) === on) return;
    header.classList.toggle(COMPACT, on);
    setOffset(on);
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    if (!desktop.matches || y < START) {
      setCompact(false);
      lastY = y;
      return;
    }
    if (Math.abs(y - lastY) < SLACK) return;
    if (y > lastY && !busy()) setCompact(true);
    else if (y < lastY) setCompact(false);
    lastY = y;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true },
  );

  // Keyboard users: tabbing into the header always shows the menu row.
  // (theme.js also focuses a menu trigger on hover, hence :focus-visible.)
  header.addEventListener("focusin", function () {
    if (header.querySelector(":focus-visible")) setCompact(false);
  });

  desktop.addEventListener("change", update);
})();
